import { API_BASE, apiFetch } from "@/client/lib/api";

/**
 * Customer-facing maintenance API. The portal is the single source of truth;
 * these are tenant-scoped reads that feed both the top-of-portal banner and the
 * calendar page. `icalUrl` is a tokenized feed the customer can subscribe to.
 */

export type MaintenanceKind = "scheduled" | "emergency";
export type MaintenanceStatus = "scheduled" | "in_progress" | "completed" | "cancelled";

export interface MaintenanceWindow {
  id: string;
  title: string;
  description: string;
  kind: MaintenanceKind;
  status: MaintenanceStatus;
  startsAt: string;
  endsAt: string | null;
  updatedAt: string;
}

export const maintenanceApi = {
  list: () => apiFetch<{ windows: MaintenanceWindow[]; icalUrl: string | null }>("/maintenance"),
  /**
   * Same-origin, cookie-authenticated URL for a single window's .ics. The
   * endpoint sets Content-Disposition: attachment, so a plain download link
   * adds the event to the user's calendar without subscribing to the feed.
   */
  windowIcsUrl: (id: string) => `${API_BASE}/maintenance/windows/${id}/calendar.ics`,
};
